import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketQuery, TicketService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { of } from 'rxjs';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ngx-translate/core';

function SelectedTicketsTableComponent_th_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 3);
} }
function SelectedTicketsTableComponent_tr_20_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵelementStart(1, "button", 8);
    ɵngcc0.ɵɵlistener("click", function SelectedTicketsTableComponent_tr_20_td_11_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ticket_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.remove(ticket_r2.Id); });
    ɵngcc0.ɵɵelement(2, "span", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SelectedTicketsTableComponent_tr_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "th", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "td");
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "td");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, SelectedTicketsTableComponent_tr_20_td_11_Template, 3, 0, "td", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ticket_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ticket_r2.ACN);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ticket_r2.StandName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ticket_r2.AreaLine1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ticket_r2.Row);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ticket_r2.Seat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showRemoveButton);
} }
class SelectedTicketsTableComponent {
    constructor(ticketQuery, ticketService) {
        this.ticketQuery = ticketQuery;
        this.ticketService = ticketService;
        this.showRemoveButton = false;
        this.ticket = undefined;
    }
    ngOnInit() {
        if (this.ticket === undefined) {
            this.selectedTickets$ = this.ticketQuery.selectedTickets();
        }
        else {
            this.selectedTickets$ = of([this.ticket]);
        }
    }
    remove(id) {
        this.ticketService.removeSelectedTicket(id);
    }
}
SelectedTicketsTableComponent.ɵfac = function SelectedTicketsTableComponent_Factory(t) { return new (t || SelectedTicketsTableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TicketQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TicketService)); };
SelectedTicketsTableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectedTicketsTableComponent, selectors: [["fgbcl-selected-tickets-table"]], inputs: { showRemoveButton: "showRemoveButton", ticket: "ticket" }, decls: 22, vars: 19, consts: [[1, "table", "selected-tickets-table"], [1, "bg-muted"], ["scope", "col", 1, "pl-5"], ["scope", "col"], ["scope", "col", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["scope", "row", 1, "font-weight-bold", "text-primary", "pl-5"], [4, "ngIf"], ["aria-label", "Remove ticket", 1, "remove-ticket", 3, "click"], [1, "icon-close"]], template: function SelectedTicketsTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "table", 0);
        ɵngcc0.ɵɵelementStart(1, "thead", 1);
        ɵngcc0.ɵɵelementStart(2, "tr");
        ɵngcc0.ɵɵelementStart(3, "th", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "th", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "th", 3);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "th", 3);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "th", 3);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, SelectedTicketsTableComponent_th_18_Template, 1, 0, "th", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "tbody");
        ɵngcc0.ɵɵtemplate(20, SelectedTicketsTableComponent_tr_20_Template, 12, 6, "tr", 5);
        ɵngcc0.ɵɵpipe(21, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 7, "cl.selected.tickets.table.card.number"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 9, "cl.selected.tickets.table.area"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 11, "cl.selected.tickets.table.card.section"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 13, "cl.selected.tickets.table.row"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(17, 15, "cl.selected.tickets.table.seat"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRemoveButton);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(21, 17, ctx.selectedTickets$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], pipes: [ɵngcc3.TranslatePipe, ɵngcc2.AsyncPipe], styles: [""] });
SelectedTicketsTableComponent.ctorParameters = () => [
    { type: TicketQuery },
    { type: TicketService }
];
SelectedTicketsTableComponent.propDecorators = {
    showRemoveButton: [{ type: Input }],
    ticket: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedTicketsTableComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-selected-tickets-table',
                template: "<table class=\"table selected-tickets-table\">\r\n  <thead class=\"bg-muted\">\r\n    <tr>\r\n      <th scope=\"col\" class=\"pl-5\">{{ 'cl.selected.tickets.table.card.number' | translate }}</th>\r\n      <th scope=\"col\">{{ 'cl.selected.tickets.table.area' | translate }}</th>\r\n      <th scope=\"col\">{{ 'cl.selected.tickets.table.card.section' | translate }}</th>\r\n      <th scope=\"col\">{{ 'cl.selected.tickets.table.row' | translate }}</th>\r\n      <th scope=\"col\">{{ 'cl.selected.tickets.table.seat' | translate }}</th>\r\n      <th scope=\"col\" *ngIf=\"showRemoveButton\"></th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr *ngFor=\"let ticket of selectedTickets$ | async\">\r\n      <th class=\"font-weight-bold text-primary pl-5\" scope=\"row\">{{ ticket.ACN }}</th>\r\n      <td>\r\n        {{ ticket.StandName }}\r\n      </td>\r\n      <td>{{ ticket.AreaLine1 }}</td>\r\n      <td>{{ ticket.Row }}</td>\r\n      <td>{{ ticket.Seat }}</td>\r\n      <td *ngIf=\"showRemoveButton\">\r\n        <button class=\"remove-ticket\" (click)=\"remove(ticket.Id)\" aria-label=\"Remove ticket\">\r\n          <span class=\"icon-close\"></span>\r\n        </button>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.TicketQuery }, { type: ɵngcc1.TicketService }]; }, { showRemoveButton: [{
            type: Input
        }], ticket: [{
            type: Input
        }] }); })();

class SelectedTicketsTableModule {
}
SelectedTicketsTableModule.ɵfac = function SelectedTicketsTableModule_Factory(t) { return new (t || SelectedTicketsTableModule)(); };
SelectedTicketsTableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SelectedTicketsTableModule });
SelectedTicketsTableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SelectedTicketsTableModule, { declarations: function () { return [SelectedTicketsTableComponent]; }, imports: function () { return [CommonModule, ɵngcc3.TranslateModule]; }, exports: function () { return [SelectedTicketsTableComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedTicketsTableModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectedTicketsTableComponent],
                imports: [
                    CommonModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [SelectedTicketsTableComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SelectedTicketsTableComponent, SelectedTicketsTableModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-selected-tickets-table.js.map